<nz-skeleton [nzActive]="true" *ngIf="loading; else initialized"></nz-skeleton>

<ng-template #initialized>
  <div class="channel-card-list" [class.international]="isInternational">
    <div
      *ngFor="let channel of listOfChannel"
      class="channel-card flex flex-row items-center justify-between"
      (click)="clickChannel(channel.thirdparty_type)"
    >
      <!-- <img class="icon" [src]="isInternational ? channel.icon_large_en : channel.icon_large" [alt]="channel.name" />
      <div class="connect" [style.background-color]="channel.signalColor"> -->
      <img class="icon" [src]="channel?.logo" [alt]="channel.name" />
      <div class="connect" [style.background-color]="channel.bg_color">
        {{ "channel-account-channel_menu_html-关联" | translate }}
        <!-- Connect -->
        <!--      {{ "word.channel_" + channel.type | translate }}-->
        <!-- {{ platform.name }} -->
      </div>
    </div>
  </div>
</ng-template>
